import {http} from '../util/http'
import {API_EP_API_DOMAIN} from '../config'
import headers from './employeeSystemHeader'

// 获取桌台预订设置
export const reservationTableSetting = (tableId) => {
  return http({
    headers: headers(),
    url: `${API_EP_API_DOMAIN}/business-table/reservation/table/setting`,
    params: {
      tableId,
    },
  })
}
// 单个球台预订设置
export const postSingleReservationSettingData = (data) => {
  return http({
    headers: headers(),
    url: `${API_EP_API_DOMAIN}/table/reservation/table/setting`,
    method: 'post',
    data,
  })
}
// 批量球台预订设置
export const postReservationSettingData = (data) => {
  return http({
    headers: headers(),
    url: `${API_EP_API_DOMAIN}/business-table/reservation/table/setting/batch`,
    method: 'post',
    data,
  })
}

// 单个球台预订退款正常设置
export const postSingleReservationRefundSettingData = (data) => {
  return http({
    headers: headers(),
    url: `${API_EP_API_DOMAIN}/table/reservation/table/setting/refund`,
    method: 'post',
    data,
  })
}






// WEBPACK FOOTER //
// ./src/api/bookings.js